import { useState } from 'react';
import Navbar from './components/Navbar';
import Footer from '../home/components/Footer';
import SeoHead from '../../components/feature/SeoHead';

// ── 静态数据 ────────────────────────────────────────────────
const ROLES = [
  { role: 'Benoit/Alcindoro', opera: 'La Bohème', composer: 'Puccini', venue: 'Opera Company of Middlebury, Vermont', year: '2025' },
  { role: 'Betto', opera: 'Gianni Schicchi', composer: 'Puccini', venue: 'Opera Company of Middlebury, Vermont', year: '2025' },
  { role: 'Abbot Cuno', opera: 'Hildegard (Workshop)', composer: 'Sarah K. Snider', venue: 'Beth Morrison Projects & Mannes Opera, New York', year: '2025' },
  { role: 'Don Giovanni', opera: 'Don Giovanni', composer: 'Mozart', venue: 'Johnson Hall, Mannes Opera, New York', year: '2024' },
  { role: 'Count Almaviva', opera: 'Le Nozze di Figaro', composer: 'Mozart', venue: 'Trentino Music Festival, Italy', year: '2024' },
  { role: 'Lance', opera: '600 Square Feet', composer: 'Nkeiru Okoye', venue: 'Mannes Opera, New York', year: '2024' },
  { role: 'Kinesias', opera: 'Lysistrata', composer: 'Mark Adamo', venue: 'Gerald W. Lynch Theater, Mannes Opera, New York', year: '2024' },
  { role: 'Count Almaviva', opera: 'Le Nozze di Figaro', composer: 'Mozart', venue: 'Miami Music Festival, FL', year: '2023' },
  { role: 'Escamillo', opera: 'Carmen', composer: 'Bizet', venue: 'Miami Music Festival, FL', year: '2022' },
  { role: 'Peter Quince', opera: 'A Midsummer Night\'s Dream', composer: 'Benjamin Britten', venue: 'Miami Music Festival, FL', year: '2022' },
  { role: 'Die Sprecher', opera: 'Die Zauberflöte', composer: 'Mozart', venue: 'Xinghai Opera House, Guangzhou, China', year: '2017' },
];

const PARTIAL_ROLES = [
  { role: 'Soloist', opera: 'Chinese New Year Concert', composer: 'Lincoln Square Music Management & Consulting', venue: 'Carnegie Hall, NY', year: '2026' },
  { role: 'Sam', opera: 'A Quiet Place', composer: 'Leonard Bernstein', venue: 'Neidorff-Karpati Hall at Manhattan School of Music, NY', year: '2021' },
  { role: 'Leporello', opera: 'Don Giovanni', composer: 'Mozart', venue: 'Greenfield Hall at Manhattan School of Music, NY', year: '2021' },
  { role: 'Marcello', opera: 'La Bohème', composer: 'Puccini', venue: 'Greenfield Hall at Manhattan School of Music, NY', year: '2021' },
  { role: 'Guglielmo', opera: 'Così fan tutte', composer: 'Mozart', venue: 'Greenfield Hall at Manhattan School of Music, NY', year: '2021' },
  { role: 'Dottore Malatesta', opera: 'Don Pasquale', composer: 'Donizetti', venue: 'Greenfield Hall at Manhattan School of Music, NY', year: '2021' },
  { role: 'Pistola', opera: 'Falstaff', composer: 'G. Verdi', venue: 'The Riverside Church & Manhattan School of Music, NY', year: '2020' },
  { role: 'Francis Nurse', opera: 'The Crucible', composer: 'Robert Ward', venue: 'The Riverside Church & Manhattan School of Music, NY', year: '2020' },
  { role: 'Bartolo', opera: 'Le Nozze di Figaro', composer: 'Mozart', venue: 'The Riverside Church & Manhattan School of Music, NY', year: '2020' },
  { role: 'Elviro', opera: 'Serse', composer: 'G. F. Handel', venue: 'Greenfield Hall at Manhattan School of Music, NY', year: '2020' },
  { role: 'Count Almaviva', opera: 'Le Nozze di Figaro', composer: 'Mozart', venue: 'Xinghai Conservatory of Music, Guangzhou, China', year: '2017' },
  { role: 'Soloist', opera: 'Die Fledermaus', composer: 'Johann Strauss II', venue: 'Guangzhou Grand Opera House, Guangzhou, China', year: '2017' },
  { role: 'Guglielmo', opera: 'Così fan tutte', composer: 'Mozart', venue: 'Xinghai Conservatory of Music, Guangzhou, China', year: '2016' },
];

const AWARDS = [
  { award: 'Semi-Finalist', competition: 'Premiere Opera International Vocal Competition, NY', year: '2024' },
  { award: 'Gold Prize Winner', competition: 'Chinese Vocal International Competition, Singapore', year: '2016' },
  { award: 'Gold Prize for Male Voice', competition: 'International Federation of Choral Music by UNESCO, Macau', year: '2015' },
  { award: 'First Prize Winner', competition: 'China\'s Urban Chorus Contest, Shenzhen', year: '2015' },
  { award: 'Outstanding Award', competition: 'China Golden Bell Music (National Level), Suzhou', year: '2015' },
];

const LANGUAGES = ['English', 'Italian', 'German', 'French', 'Chinese', 'Cantonese', 'Russian', 'Latin'];

const VOCAL_SKILLS = [
  'Italian Bel Canto',
  'German Lieder',
  'French Mélodie',
  'Baroque Oratorios',
  'Contemporary Vocal Techniques',
  'Musical Theatre',
  'Pop & Jazz & Rock Vocal',
];

const ADDITIONAL_SKILLS = [
  'Stage Combat & Advanced Performance',
  'Historical Dance & Hip Hop Dance',
  'Piano, Violin, Electric Guitar & Drumset',
  'Music Theory & Aural Skills',
  'IPA (International Phonetic Alphabet)',
  'Martial Arts (Kung Fu, Hung Ga Kuen, Taiji)',
  'Jian Sword, Dao Saber & Staff Techniques',
];

const AFFILIATIONS = [
  { name: 'VP Artists Management', url: 'https://www.vpartistsmanagement.com/' },
  { name: 'Lincoln Square Music Management & Consulting', url: null },
  { name: 'Three Owls Artists Management and Press', url: 'https://www.3owlsartists.com/' },
  { name: 'Opera America, National Opera Center', url: 'https://www.operaamerica.org/' },
];

// ── 主页面 ──────────────────────────────────────────────────
export default function ResumePage() {
  const [isDownloading, setIsDownloading] = useState(false);
  const [showPrintTip, setShowPrintTip] = useState(false);

  const resumeJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ProfilePage',
    name: 'Wei Chen – Baritone Résumé',
    url: `${import.meta.env.VITE_SITE_URL ?? 'https://example.com'}/resume`,
    description: 'Full curriculum vitae of Wei Chen, New York baritone. Opera roles, education, awards, and skills.',
    mainEntity: {
      '@type': 'Person',
      name: 'Wei Chen',
      jobTitle: 'Baritone',
      email: 'weichenvictor@gmail.com',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'New York',
        addressRegion: 'NY',
        addressCountry: 'US',
      },
      alumniOf: [
        { '@type': 'EducationalOrganization', name: 'Mannes School of Music, The New School' },
        { '@type': 'EducationalOrganization', name: 'Manhattan School of Music' },
        { '@type': 'EducationalOrganization', name: 'Xinghai Conservatory of Music' },
      ],
      award: [
        'Semi-Finalist, Premiere Opera International Vocal Competition, NY (2024)',
        'Gold Prize Winner, Chinese Vocal International Competition, Singapore (2016)',
        'Gold Prize for Male Voice, International Federation of Choral Music by UNESCO, Macau (2015)',
      ],
      knowsLanguage: ['English', 'Italian', 'German', 'French', 'Chinese', 'Cantonese', 'Russian', 'Latin'],
    },
  };

  const handleDownload = () => {
    try {
      setIsDownloading(true);
      setShowPrintTip(false);
      setTimeout(() => {
        setIsDownloading(false);
        try { window.print(); } catch (e) { console.error(e); }
      }, 500);
    } catch (err) {
      console.error(err);
      setIsDownloading(false);
    }
  };

  return (
    <div className="min-h-screen bg-deep-black">
      <SeoHead
        title="Wei Chen – Baritone Résumé | Opera Roles, Education & Awards"
        description="Curriculum vitae of Wei Chen, New York baritone. Opera roles at Carnegie Hall, Mannes Opera, Miami Music Festival. Education at Manhattan School of Music and Mannes."
        keywords="Wei Chen Résumé, Baritone CV, Opera Roles, Manhattan School of Music, Mannes Opera, Carnegie Hall"
        canonical="/resume"
        jsonLd={resumeJsonLd}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-24 md:pt-32 pb-12 md:pb-20 px-4 md:px-6 border-b border-champagne-gold/20 overflow-hidden">
        {/* Marble Checkerboard Background */}
        <div className="absolute inset-0 z-0">
          <img
            src="https://public.readdy.ai/ai/img_res/edited_52313795a64d92c0d526109107e099c3_ed141df2.jpg"
            alt="marble background"
            className="w-full h-full object-cover object-center"
          />
          {/* Overlay to ensure text readability */}
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/65"></div>
          {/* Top & bottom edge darkening */}
          <div className="absolute inset-0 pointer-events-none" style={{ background: 'linear-gradient(to bottom, rgba(0,0,0,0.35) 0%, transparent 22%, transparent 72%, rgba(0,0,0,0.72) 100%)' }}></div>
        </div>

        <div className="relative z-10 max-w-5xl mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 border border-champagne-gold/50 rounded-sm mb-5 md:mb-6">
              <i className="ri-file-text-line text-sm" style={{ color: '#c9a84c' }}></i>
              <span className="font-cormorant text-sm tracking-wider" style={{ color: '#c9a84c' }}>CURRICULUM VITAE</span>
            </div>
            <h1 className="text-3xl md:text-6xl font-cinzel-decorative font-bold mb-3 md:mb-4" style={{ color: '#c9a84c', textShadow: '0 2px 12px rgba(0,0,0,0.8)' }}>
              Wei Chen
            </h1>
            <p className="text-lg md:text-2xl font-cormorant italic mb-5 md:mb-6" style={{ color: '#b8943a' }}>Baritone</p>
            <div className="flex items-center justify-center font-cormorant text-base md:text-lg">
              <a href="mailto:weichenvictor@gmail.com" className="transition-colors duration-300 cursor-pointer flex items-center gap-2 hover:opacity-100" style={{ color: '#ede8d8', opacity: 0.8, textShadow: '0 2px 8px rgba(0,0,0,0.8)' }}>
                <i className="ri-mail-line"></i>weichenvictor@gmail.com
              </a>
            </div>
          </div>

          {/* Print / Export PDF Button Area */}
          <div className="flex flex-col items-center gap-4">
            <div className="flex items-center gap-3">
              <button
                onClick={handleDownload}
                disabled={isDownloading}
                className="group px-6 md:px-8 py-3 md:py-4 bg-champagne-gold text-deep-black font-cormorant text-sm md:text-base tracking-wider hover:bg-champagne-gold/90 transition-all duration-300 flex items-center gap-3 whitespace-nowrap cursor-pointer disabled:opacity-50"
              >
                <i className={`ri-printer-line text-lg ${isDownloading ? 'animate-pulse' : 'group-hover:scale-110 transition-transform'}`}></i>
                {isDownloading ? 'Opening Print Dialog...' : 'Print / Export PDF'}
              </button>
              <button
                onClick={() => setShowPrintTip(!showPrintTip)}
                className="w-9 h-9 flex items-center justify-center border border-champagne-gold/40 hover:border-champagne-gold/80 hover:bg-champagne-gold/10 transition-all duration-300 cursor-pointer"
                title="How to export PDF"
                style={{ color: '#c9a84c' }}
              >
                <i className="ri-question-line text-base"></i>
              </button>
            </div>

            {/* Print Tip Panel */}
            {showPrintTip && (
              <div className="max-w-md w-full border border-champagne-gold/30 bg-black/40 backdrop-blur-sm px-5 py-4 text-left">
                <div className="flex items-center gap-2 mb-3">
                  <i className="ri-information-line text-base" style={{ color: '#c9a84c' }}></i>
                  <span className="font-cormorant text-sm font-semibold tracking-wide" style={{ color: '#c9a84c' }}>How to Save as PDF</span>
                </div>
                <ol className="space-y-1.5 font-cormorant text-sm" style={{ color: '#ede8d8', opacity: 0.8 }}>
                  <li className="flex items-start gap-2">
                    <span className="font-semibold" style={{ color: '#c9a84c' }}>1.</span>
                    Click <strong>"Print / Export PDF"</strong> to open the print dialog.
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-semibold" style={{ color: '#c9a84c' }}>2.</span>
                    In the <strong>Destination</strong> field, select <strong>"Save as PDF"</strong>.
                  </li>
                  <li className="flex items-start gap-2">
                    <span className="font-semibold" style={{ color: '#c9a84c' }}>3.</span>
                    Click <strong>"Save"</strong> to download your PDF résumé.
                  </li>
                </ol>
                <p className="font-cormorant text-xs mt-3" style={{ color: '#ede8d8', opacity: 0.5 }}>
                  Tip: Works on Chrome, Safari, Firefox, and Edge.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-10 md:py-20 px-4 md:px-6">
        <div className="max-w-5xl mx-auto">

          {/* Professional Summary */}
          <div className="mb-10 md:mb-16">
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8">
              <div className="w-9 h-9 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center bg-champagne-gold/10 border border-champagne-gold/30">
                <i className="ri-user-star-line text-base md:text-xl" style={{ color: '#c9a84c' }}></i>
              </div>
              <h2 className="text-xl md:text-3xl font-cinzel-decorative" style={{ color: '#c9a84c', textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>Professional Summary</h2>
            </div>
            <p className="font-cormorant text-base md:text-xl leading-relaxed pl-0 md:pl-16" style={{ color: '#ede8d8', opacity: 0.85 }}>
              A rising young Baritone, Wei Chen brings extensive performance experience to the stage, having sung leading roles on both intimate and major stages across Europe, Asia, and North America. He excels in Baroque, Classical, Romantic, and Contemporary repertoire, and is particularly celebrated for his interpretations of Mozart, Donizetti, and Rossini. Known for his rich, resonant tone, powerful dramatic expression, and nuanced character portrayals, he is deeply committed to artistic excellence and collaborative teamwork.
            </p>
          </div>

          {/* Education */}
          <div className="mb-10 md:mb-16">
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8">
              <div className="w-9 h-9 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center bg-champagne-gold/10 border border-champagne-gold/30">
                <i className="ri-graduation-cap-line text-base md:text-xl" style={{ color: '#c9a84c' }}></i>
              </div>
              <h2 className="text-xl md:text-3xl font-cinzel-decorative" style={{ color: '#c9a84c', textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>Education</h2>
            </div>
            <div className="pl-0 md:pl-16 space-y-6 md:space-y-8">
              {[
                { school: 'Mannes School of Music, The New School', degree: 'Professional Studies Diploma, New York City, US', years: '2023 – 2025', desc: 'Received a full scholarship to the Mannes School of Music. Studied under renowned Voice Professor, Chair of the Voice Department: William Burden and famous Vocal Coach Joshua Greene.' },
                { school: 'Manhattan School of Music', degree: 'Master of Music, New York City, US', years: '2019 – 2021', desc: 'Studied under the Chair of the Voice Department: Prof. Maitland Peters. Participated in many masterclasses, performed several Operas and scenes as leading Baritones in MSM.' },
                { school: 'Xinghai Conservatory of Music', degree: 'Bachelor of Music, Guangzhou, China', years: '2013 – 2017', desc: 'Studied under renowned voice Professor: Guodong Feng. Specialized in Italian, German, French and Chinese operatic repertoire. Graduated as an Outstanding Graduate, Top Student in Voice Performance, and Honorary President of the Student Union.' },
              ].map((edu, idx) => (
                <div key={idx} className="border-l-2 border-emerald-green/30 pl-4 md:pl-8 py-2">
                  <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-1 mb-2">
                    <h3 className="text-base md:text-xl font-playfair" style={{ color: '#ede8d8' }}>{edu.school}</h3>
                    <span className="font-cormorant text-sm md:text-base whitespace-nowrap" style={{ color: '#c9a84c' }}>{edu.years}</span>
                  </div>
                  <p className="font-cormorant text-base md:text-lg mb-2" style={{ color: '#b8943a' }}>{edu.degree}</p>
                  <p className="font-cormorant text-sm md:text-base" style={{ color: '#ede8d8', opacity: 0.6 }}>{edu.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* ── Major Roles & Productions ── */}
          <div className="mb-10 md:mb-16">
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8">
              <div className="w-9 h-9 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center bg-champagne-gold/10 border border-champagne-gold/30">
                <i className="ri-music-2-line text-base md:text-xl" style={{ color: '#c9a84c' }}></i>
              </div>
              <h2 className="text-xl md:text-3xl font-cinzel-decorative" style={{ color: '#c9a84c', textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>Major Roles &amp; Productions</h2>
            </div>
            <div className="pl-0 md:pl-16 space-y-1">
              {ROLES.map((item, index) => (
                <div key={index} className="flex items-start gap-3 md:gap-6 hover:bg-champagne-gold/5 p-2.5 md:p-4 transition-all duration-300">
                  <span className="font-cormorant text-base md:text-lg whitespace-nowrap pt-0.5 min-w-[44px] md:min-w-[60px]" style={{ color: '#c9a84c', opacity: 0.85 }}>{item.year}</span>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-baseline gap-1 md:gap-2 mb-1">
                      <span className="text-base md:text-xl font-playfair" style={{ color: '#ede8d8' }}>{item.role}</span>
                      <span style={{ color: '#ede8d8', opacity: 0.3 }}>•</span>
                      <span className="font-cormorant italic text-base md:text-lg" style={{ color: '#b8943a' }}>{item.opera}</span>
                      <span className="text-sm md:text-base" style={{ color: '#ede8d8', opacity: 0.35 }}>(</span>
                      <span className="text-sm md:text-base" style={{ color: '#ede8d8', opacity: 0.6 }}>{item.composer}</span>
                      <span className="text-sm md:text-base" style={{ color: '#ede8d8', opacity: 0.35 }}>)</span>
                    </div>
                    <span className="font-cormorant text-sm md:text-base block leading-snug" style={{ color: '#ede8d8', opacity: 0.6 }}>{item.venue}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Partial Roles, Scenes and Concerts ── */}
          <div className="mb-10 md:mb-16">
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8">
              <div className="w-9 h-9 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center bg-champagne-gold/10 border border-champagne-gold/30">
                <i className="ri-mic-line text-base md:text-xl" style={{ color: '#c9a84c' }}></i>
              </div>
              <h2 className="text-xl md:text-3xl font-cinzel-decorative" style={{ color: '#c9a84c', textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>Partial Roles, Scenes and Concerts</h2>
            </div>
            <div className="pl-0 md:pl-16 space-y-1">
              {PARTIAL_ROLES.map((item, index) => (
                <div key={index} className="flex items-start gap-3 md:gap-6 hover:bg-champagne-gold/5 p-2.5 md:p-4 transition-all duration-300">
                  <span className="font-cormorant text-base md:text-lg whitespace-nowrap pt-0.5 min-w-[44px] md:min-w-[60px]" style={{ color: '#c9a84c', opacity: 0.85 }}>{item.year}</span>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-baseline gap-1 md:gap-2 mb-1">
                      <span className="text-base md:text-xl font-playfair" style={{ color: '#ede8d8' }}>{item.role}</span>
                      <span style={{ color: '#ede8d8', opacity: 0.3 }}>•</span>
                      <span className="font-cormorant italic text-base md:text-lg" style={{ color: '#b8943a' }}>{item.opera}</span>
                      <span className="text-sm md:text-base" style={{ color: '#ede8d8', opacity: 0.35 }}>(</span>
                      <span className="text-sm md:text-base" style={{ color: '#ede8d8', opacity: 0.6 }}>{item.composer}</span>
                      <span className="text-sm md:text-base" style={{ color: '#ede8d8', opacity: 0.35 }}>)</span>
                    </div>
                    <span className="font-cormorant text-sm md:text-base block leading-snug" style={{ color: '#ede8d8', opacity: 0.6 }}>{item.venue}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Awards & Honors ── */}
          <div className="mb-10 md:mb-16">
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8">
              <div className="w-9 h-9 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center bg-champagne-gold/10 border border-champagne-gold/30">
                <i className="ri-trophy-line text-base md:text-xl" style={{ color: '#c9a84c' }}></i>
              </div>
              <h2 className="text-xl md:text-3xl font-cinzel-decorative" style={{ color: '#c9a84c', textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>Awards &amp; Honors</h2>
            </div>
            <div className="pl-0 md:pl-16 space-y-1">
              {AWARDS.map((item, index) => (
                <div key={index} className="flex items-start gap-3 md:gap-6 hover:bg-champagne-gold/5 p-2.5 md:p-3 transition-all duration-300">
                  <span className="font-cormorant text-base md:text-lg whitespace-nowrap min-w-[44px] md:min-w-[60px]" style={{ color: '#c9a84c', opacity: 0.85 }}>{item.year}</span>
                  <div className="w-2 h-2 flex-shrink-0 mt-2 bg-emerald-green/50 rounded-full"></div>
                  <div className="flex-1 min-w-0">
                    <span className="font-playfair text-base md:text-lg block mb-0.5" style={{ color: '#ede8d8' }}>{item.award}</span>
                    <span className="font-cormorant text-sm md:text-base block leading-snug" style={{ color: '#ede8d8', opacity: 0.6 }}>{item.competition}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Languages ── */}
          <div className="mb-10 md:mb-16">
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8">
              <div className="w-9 h-9 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center bg-champagne-gold/10 border border-champagne-gold/30">
                <i className="ri-global-line text-base md:text-xl" style={{ color: '#c9a84c' }}></i>
              </div>
              <h2 className="text-xl md:text-3xl font-cinzel-decorative" style={{ color: '#c9a84c', textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>Languages</h2>
            </div>
            <div className="pl-0 md:pl-16 flex flex-wrap gap-2.5 md:gap-4">
              {LANGUAGES.map((lang, index) => (
                <div key={index} className="border border-champagne-gold/20 px-4 md:px-6 py-2 md:py-3 hover:border-champagne-gold/50 hover:bg-champagne-gold/5 transition-all duration-300">
                  <span className="font-playfair text-sm md:text-base" style={{ color: '#ede8d8' }}>{lang}</span>
                </div>
              ))}
            </div>
          </div>

          {/* ── Skills & Specializations ── */}
          <div className="mb-10 md:mb-16">
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8">
              <div className="w-9 h-9 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center bg-champagne-gold/10 border border-champagne-gold/30">
                <i className="ri-star-line text-base md:text-xl" style={{ color: '#c9a84c' }}></i>
              </div>
              <h2 className="text-xl md:text-3xl font-cinzel-decorative" style={{ color: '#c9a84c', textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>Skills &amp; Specializations</h2>
            </div>
            <div className="pl-0 md:pl-16 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-6">
              <div className="border-l-2 border-emerald-green/30 pl-4 md:pl-6 py-2">
                <h3 className="text-base md:text-lg font-playfair mb-4" style={{ color: '#ede8d8' }}>Vocal Techniques</h3>
                <ul className="space-y-2.5">
                  {VOCAL_SKILLS.map((skill, idx) => (
                    <li key={idx} className="font-cormorant text-base md:text-lg flex items-center gap-2" style={{ color: '#ede8d8', opacity: 0.7 }}>
                      <i className="ri-checkbox-circle-line text-emerald-green text-base flex-shrink-0"></i>
                      {skill}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="border-l-2 border-emerald-green/30 pl-4 md:pl-6 py-2">
                <h3 className="text-base md:text-lg font-playfair mb-4" style={{ color: '#ede8d8' }}>Additional Skills</h3>
                <ul className="space-y-2.5">
                  {ADDITIONAL_SKILLS.map((skill, idx) => (
                    <li key={idx} className="font-cormorant text-base md:text-lg flex items-center gap-2" style={{ color: '#ede8d8', opacity: 0.7 }}>
                      <i className="ri-checkbox-circle-line text-emerald-green text-base flex-shrink-0"></i>
                      {skill}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

          {/* ── Professional Affiliations ── */}
          <div className="mb-10 md:mb-16">
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8">
              <div className="w-9 h-9 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center bg-champagne-gold/10 border border-champagne-gold/30">
                <i className="ri-team-line text-base md:text-xl" style={{ color: '#c9a84c' }}></i>
              </div>
              <h2 className="text-xl md:text-3xl font-cinzel-decorative" style={{ color: '#c9a84c', textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>Professional Affiliations</h2>
            </div>
            <div className="pl-0 md:pl-16 space-y-3">
              {AFFILIATIONS.map((affiliation, index) => (
                <div key={index} className="flex items-start gap-3 md:gap-4 font-cormorant text-base md:text-lg" style={{ color: '#ede8d8', opacity: 0.75 }}>
                  <i className="ri-arrow-right-s-line text-emerald-green flex-shrink-0 mt-0.5 text-lg"></i>
                  {affiliation.url ? (
                    <a
                      href={affiliation.url}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="hover:opacity-100 transition-opacity duration-300 underline underline-offset-2 cursor-pointer"
                      style={{ color: '#c9a84c', opacity: 0.85 }}
                    >
                      {affiliation.name}
                    </a>
                  ) : (
                    <span>{affiliation.name}</span>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* ── References ── */}
          <div>
            <div className="flex items-center gap-3 md:gap-4 mb-5 md:mb-8">
              <div className="w-9 h-9 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center bg-champagne-gold/10 border border-champagne-gold/30">
                <i className="ri-file-user-line text-base md:text-xl" style={{ color: '#c9a84c' }}></i>
              </div>
              <h2 className="text-xl md:text-3xl font-cinzel-decorative" style={{ color: '#c9a84c', textShadow: '0 2px 8px rgba(0,0,0,0.7)' }}>Resume on Request</h2>
            </div>
            <div className="pl-0 md:pl-16">
              <p className="font-cormorant text-base md:text-xl italic leading-relaxed" style={{ color: '#ede8d8', opacity: 0.75 }}>
                Please do not hesitate to contact me should you require a professional résumé, which I would be delighted to send in PDF format.
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* Decorative Bottom */}
      <section className="py-16 px-6 border-t border-champagne-gold/20">
        <div className="max-w-5xl mx-auto text-center">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="h-px w-32 bg-champagne-gold/30"></div>
            <div className="w-6 h-6 flex items-center justify-center opacity-60" style={{ color: '#c9a84c' }}>
              <i className="ri-music-fill"></i>
            </div>
            <div className="h-px w-32 bg-champagne-gold/30"></div>
          </div>
          <p className="font-cormorant text-base mb-8" style={{ color: '#ede8d8', opacity: 0.55, textShadow: '0 1px 3px rgba(0,0,0,0.4)' }}>
            For booking inquiries and additional information, please contact
          </p>
          <a
            href="/#contact"
            className="inline-flex items-center gap-2 px-8 py-4 border font-cormorant text-base tracking-wider hover:bg-champagne-gold hover:text-deep-black transition-all duration-300 whitespace-nowrap cursor-pointer"
            style={{ color: '#c9a84c', borderColor: '#c9a84c', textShadow: '0 1px 4px rgba(0,0,0,0.5)' }}
          >
            Get in Touch
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </section>

      <Footer />
    </div>
  );
}
